<!--<div class="text-center">-->
<!--    <i class="fal fa-times close-btn" title="Đóng" (click)="close()"></i>-->
<!--    <label for="" class="font-weight-bold">{{ area !== 0 ? "Total area" : "Total length" }}</label>-->
<!--    <p class="mb-0" *ngIf="area !== 0">-->
<!--        {{ area | number }} km²-->
<!--    </p>-->
<!--    <p class="mb-0" *ngIf="length !== 0">-->
<!--        {{ length | number }} km-->
<!--    </p>-->
<!--</div>-->
<div class="text-center">
    <button class="button-1" role="button" (click)="close()">Cancel</button>
    <button class="button-2" role="button">Delete All</button>
</div>
